import { default as SubscriptionDataRetentionMinDatePicker } from './DatePicker';
import { default as SubscriptionDataRetentionMinDateTimePicker } from './DateTimePicker';

export const DataRetentionMinComponents = {
  DatePicker: SubscriptionDataRetentionMinDatePicker,
  DateTimePicker: SubscriptionDataRetentionMinDateTimePicker,
};
